import React, {useEffect,useState} from 'react';
import { useHistory,useParams } from 'react-router-dom'
import RegistrationCard from '../../components/RegistrationCard/RegistrationCard';
import UserService from '../../services/UserService';
import PhiusLogo from '../../images/Phius-Logo.png';
 import './RegistrationPage.css'

export default function RegistrationPage() {
  const [email,setEmail] = useState("");
  const history = useHistory()
  const handleLoginSuccess = () => {
    history.push('/');
    // or push success modal, prompt close or add another?
  };
  const { hash } = useParams()

  useEffect(()=>{
    // grab hash from params, send to node, if node returns email, render page, else, redirect
    UserService.decryptUser(hash).then(email =>{
      // if ok
      setEmail(email.Email)
    })
    .catch(e =>{
      // if email does not exist in db/crm, redirect out of registration page
      console.log("error: ",e.message)
      console.log("registration error: ",e)
      //history.push('/');
    })
  },[hash])

  return (
    <section className="registration-page">
    <RegistrationCard email={email} logoSrc={PhiusLogo} onRegSuccess={handleLoginSuccess} />
    <div>
      <ul class="nav-items">
        <h2>Quick Links</h2>
        <li>
          <li>
            <a target="_blank" rel="noreferrer" href="https://training.phius.org/">
              Go to Training Site
            </a>
          </li>
          <li>
            <a target="_blank" rel="noreferrer" href="https://www.phius.org/alliance/membership">

                Become a Member
            </a>
          </li>
        <li>
          <a href="/events">

              Events
          </a>
        </li>
        <li>
          <a target="_blank" rel="noreferrer" href="https://forms.zohopublic.com/phius/form/ContactPhius/formperma/_u3NnJ8_l4Bcia3a4bHvPvSJQU7OKKtq-LLaVhyKeuM">

              Contact Phius
          </a>
        </li>
        </li>
      </ul>
    </div>
  </section>
  )
}

